module.exports = __webpack_public_path__ + "static/media/database.b0e48af5.svg";